import { createContext, useContext } from "react";
/**
 * The sole purpose of this abstraction is to allow Next.js to swap the lazy
 * components with the actual components, because framework handles the chunk splitting.
 * Having a redundant indirection would cause performance regression.
 */ export var createDependencyInjectableComponent = function(DefaultComponent) {
    var DependencyInjectableComponentContext = /*#__PURE__*/ createContext(DefaultComponent);
    return {
        useDependencyInjectableComponent: function() {
            return useContext(DependencyInjectableComponentContext);
        },
        DependencyInjectableComponentProvider: DependencyInjectableComponentContext.Provider
    };
};
